import { Entity } from '../entity/entity';
import { EntityType } from '../entity/entity-type';
import { InvestmentJurisdiction } from '../entity/investment-jurisdiction';
import { SecurityQuestionAnswer } from './security-question-answer';
import { SecurityStatus } from './security-status';
import { SecurityTaxResultItem } from './security-tax-result-item';
import { SecurityType } from './security-type';
import { TransactionType } from './transaction-type';

export class SecurityReview {
  securityId!: number;
  generalRateEntityTypeId?: number;
  generalRateEntityType?: EntityType;
  entity!: Entity;
  investmentJurisdiction!: InvestmentJurisdiction;
  transactionType!: TransactionType;
  securityType!: SecurityType;
  securityStatus!: SecurityStatus;
  securityTaxResultItems!: SecurityTaxResultItem[];
  securityQuestionAnswers!: SecurityQuestionAnswer[];
  name!: string;
  isinCusip!: string;
  description!: string;
  acquisitionDate!: string;
  dispositionDate?: string;
  isActive!: boolean;
  created!: string;
  createdBy!: string;
  modified!: string;
  modifiedBy!: string;
  comment!: string;
  adminComment?: string;
  adminCommentModifiedBy?: string;
  adminCommentModifiedDate?: string;
}
